/* snr-hero-typer.js — "Star Name:" typewriter under the hero headline.
   Loops suggestions until the visitor types a name (hero input / snr:starName), then shows their name.
   prefers-reduced-motion: static first suggestion. Never changes letter case. */
(function () {
  var el = document.querySelector('[data-snr-typer]'); if (!el) return;
  var out = el.querySelector('.snr-typer__text');
  var list = (el.getAttribute('data-names') || 'Grandad Jimmy|Hazel Joyce King|Dans Birthday Star').split('|');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timer = 0, i = 0, pos = 0, del = false, user = '';
  function stored() { try { return (localStorage.getItem('snr:starName') || '').trim(); } catch (e) { return ''; } }
  var sr = el.querySelector('.snr-typer__sr');
  function show(t) { out.textContent = t; }
  function tick() {
    var w = list[i];
    if (!del) { pos++; show(w.slice(0, pos)); if (pos >= w.length) { del = true; timer = setTimeout(tick, 1600); return; } timer = setTimeout(tick, 70 + Math.random() * 50); }
    else { pos--; show(w.slice(0, pos)); if (pos <= 0) { del = false; i = (i + 1) % list.length; timer = setTimeout(tick, 400); return; } timer = setTimeout(tick, 35); }
  }
  function start() { clearTimeout(timer); el.classList.remove('is-user'); if (reduce) { el.classList.add('is-static'); show(list[0]); return; } pos = 0; del = false; tick(); }
  function setUser(n) {
    n = (n || '').trim().slice(0, 60);
    if (n === user) return; user = n;
    if (n) { clearTimeout(timer); el.classList.add('is-user'); show(n); if (sr) sr.textContent = 'Star Name: ' + n; } else { if (sr) sr.textContent = 'Star Name: ' + list[0]; start(); }
  }
  document.addEventListener('input', function (e) { var t = e.target; if (t && t.closest && t.closest('.snr-hero [data-snr-namebox]')) setUser(t.value); });
  document.addEventListener('snr:starname', function (e) { setUser(e.detail && e.detail.name); });
  user = stored(); if (user) { el.classList.add('is-user'); show(user); } else start();
})();
